import React, { useState, useEffect } from 'react';
import { apiClient } from '../../components/api/ApiClient';
import { Link } from 'react-router-dom';

const CATEGORIES = [
    { value: 'technical', label: 'واحد فنی' },
    { value: 'sale', label: 'واحد فروش' },
];

const PRIORITIES = [
    { value: 'low', label: 'کم' },
    { value: 'medium', label: 'متوسط' },
    { value: 'high', label: 'زیاد' },
];

function TicketList() {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState({
        status: '',
        priority: '',
        category: ''
    });

    const filteredTickets = tickets.filter(ticket => {
        if (filters.status && ticket.status !== filters.status) return false;
        if (filters.priority && ticket.priority !== filters.priority) return false;
        if (filters.category && ticket.category !== filters.category) return false;
        return true;
    });

    useEffect(() => {
        fetchTickets();
        const interval = setInterval(fetchTickets, 60000);
        return () => clearInterval(interval);
    }, []);

    const fetchTickets = async () => {
        try {
            const data = await apiClient('/internal-network/api/ticket/', { method: 'GET' });
            if (Array.isArray(data)) {
                setTickets(data);
            }
        } catch (error) {
            console.error("Error fetching tickets:", error);
        } finally {
            setLoading(false);
        }
    };

    const getCategoryLabel = (cat) => CATEGORIES.find(c => c.value === cat)?.label || cat;
    const getPriorityLabel = (p) => PRIORITIES.find(item => item.value === p)?.label || p;

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card stretch stretch-full">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h5 className="card-title">لیست تیکت‌ها</h5>
                        <Link to="/ticket/create/" className="btn btn-primary">
                            درخواست تیکت جدید
                        </Link>
                    </div>
                    <div className="card-body p-0">
                        <div className="p-4 border-bottom">
                            <div className="row g-3">
                                <div className="col-md-3">
                                    <label className="form-label">وضعیت</label>
                                    <select
                                        className="form-select"
                                        value={filters.status}
                                        onChange={(e) => setFilters({ ...filters, status: e.target.value })}
                                    >
                                        <option value="">همه</option>
                                        <option value="open">باز</option>
                                        <option value="closed">بسته</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">اولویت</label>
                                    <select
                                        className="form-select"
                                        value={filters.priority}
                                        onChange={(e) => setFilters({ ...filters, priority: e.target.value })}
                                    >
                                        <option value="">همه</option>
                                        {PRIORITIES.map(p => (
                                            <option key={p.value} value={p.value}>{p.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">دپارتمان</label>
                                    <select
                                        className="form-select"
                                        value={filters.category}
                                        onChange={(e) => setFilters({ ...filters, category: e.target.value })}
                                    >
                                        <option value="">همه</option>
                                        {CATEGORIES.map(c => (
                                            <option key={c.value} value={c.value}>{c.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-3 d-flex align-items-end">
                                    <button
                                        className="btn btn-danger w-100"
                                        onClick={() => setFilters({ status: '', priority: '', category: '' })}
                                    >
                                        پاک کردن فیلترها
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>عنوان</th>
                                        <th>دپارتمان</th>
                                        <th>اولویت</th>
                                        <th>آخرین بروزرسانی</th>
                                        <th>وضعیت</th>
                                        <th className="text-end">عملیات</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredTickets.length > 0 ? (
                                        filteredTickets.map((ticket) => (
                                            <tr key={ticket.id} className="single-item">
                                                <td>
                                                    <p className="fw-bold">
                                                        {ticket.title}
                                                    </p>
                                                </td>
                                                <td>{getCategoryLabel(ticket.category)}</td>
                                                <td>{getPriorityLabel(ticket.priority)}</td>
                                                <td>{ticket.last_message_time}</td>
                                                <td>
                                                    <span className={`badge bg-soft-${ticket.status === 'open' ? 'success' : 'secondary'} text-${ticket.status === 'open' ? 'success' : 'secondary'}`}>
                                                        {ticket.status === 'open' ? 'باز' : 'بسته'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="hstack gap-2 justify-content-end">
                                                        <Link to={`/ticket/chat/${ticket.id}`} className="avatar-text avatar-md">
                                                            <i className="feather feather-eye"></i>
                                                        </Link>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6" className="text-center py-4 text-dark">
                                                {loading ? 'در حال بارگذاری...' : 'هیچ تیکتی یافت نشد.'}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TicketList;
